import { AxiosError } from 'axios';
import api from '../../../services/cle';
import { useEffect, useState } from 'react';
import { useAppSelector } from '../../../store/hooks';
import Spinner from '../../../rxlib/components/spinner';
import { tratarErroApi } from '../../../rxlib/services/utilitarios';
import { usuarioTemPermissao } from '../../../rxlib/services/seguranca';
import AcessoBloqueado from '../../../rxlib/components/acesso-bloqueado';
import { RxlibLayout } from '../../../rxlib/components/layout/rxlib-Layout';
import { ModalWarning } from '../../../rxlib/components/modal/modal-warning';
import { VerticalTimeline } from '../../../rxlib/components/vertical-timeline';
import Breadcrumb, { BreadcrumbItem } from '../../../rxlib/components/breadcrumb';
import { ApiError, LicencaOrganizacaoHistoricoProps } from '../../../services/tipos';

function LicencaOrganizacaoHistorico(props: LicencaOrganizacaoHistoricoProps) {
    const [carregando, setCarregando] = useState<boolean>(false);
    const [showWarning, setShowWarning] = useState<boolean>(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [messageWarning, setMessageWarning] = useState<string[]>([]);
    const [nomeOrganizacao, setNomeOrganizacao] = useState<string>('');
    const [descricaoLicencaOrganizacao, setDescricaoLicencaOrganizacao] = useState<string>('');
    const [historicosLicencaOrganizacao, setHistoricosLicencaOrganizacao] = useState<[{}]>([{}]);

    const handleHide = () => setShowWarning(false);

    const breadcrumbs: BreadcrumbItem[] = [
        { texto: 'Home', link: '/home' },
        { texto: 'Organizações e unidades', link: '/organizacao' },
        { texto: 'Licenças da organização', link: `/organizacao/licenca/${props.match.params.idorganizacao}` },
        { texto: 'Histórico', link: '' },
    ];

    const temPermissao = usuarioTemPermissao(token, 'licenca_organizacao_historico');

    useEffect(() => {
        if (temPermissao) {
            if (props.match.params.idorganizacao) {
                setCarregando(true);
                Promise.all([
                    api.get(`/OData/HistoricoLicencaOrganizacao?$expand=usuario&$filter=idLicencaOrganizacao eq ${props.match.params.id}&$orderby=data desc`),
                    api.get(`/Organizacao/${props.match.params.idorganizacao}`),
                    api.get(`/LicencaOrganizacao/${props.match.params.id}`),
                ]).then(response => {
                    setTimeout(() => {
                        setDescricaoLicencaOrganizacao(response[2].data.descricao);
                        setHistoricosLicencaOrganizacao(response[0].data.value);
                        setNomeOrganizacao(response[1].data.nome);
                        setCarregando(false);
                    }, 250);
                }).catch((error: AxiosError<ApiError>) => {
                    setCarregando(false);
                    setMessageWarning(tratarErroApi(error, 'Não foi possível realizar a consulta: '));
                    setShowWarning(true);
                });
            }
        }
    }, [props.match.params.idorganizacao, props.match.params.id, temPermissao]);

    return (
        <>
            <RxlibLayout>
                <Breadcrumb
                    itens={breadcrumbs} />
                <form className='mb-5'>
                    <div className='container-fluid'>
                        <div className='row px-1'>
                            <div className='col-12'>
                                <h6>{`Histórico da licença ${descricaoLicencaOrganizacao} da organização ${nomeOrganizacao}`}</h6>
                            </div>
                        </div>
                        <div className='row px-1'>
                            <div className='col-12'>
                                {
                                    carregando
                                        ? <Spinner
                                            classStyle='rxlib-spinner' />
                                        : <VerticalTimeline
                                            campoData='Data'
                                            campoTitulo='Nome'
                                            campoTexto='Observacao'
                                            campoTituloPai='Usuario'
                                            campoInformacoes='Dados'
                                            fonteDados={historicosLicencaOrganizacao} />
                                }
                            </div>
                        </div>
                    </div>
                </form>
                <ModalWarning
                    show={showWarning}
                    onHide={handleHide}
                    message={messageWarning} />
                <AcessoBloqueado
                    permissao={temPermissao} />
            </RxlibLayout>
        </>
    );
}

export default LicencaOrganizacaoHistorico;